import React, { useState, useRef, useEffect } from 'react';
import handleupload from '../../utilities/handleUpload';
import { Edit } from '@mui/icons-material';
import PDFViewer from '../../utilities/PDFViewer';
import { Media } from 'reactstrap';
import { toast } from 'react-toastify';

const FileUploadComponent = ({
  name,
  setValue,
  trigger,
  data,
  register,
  imageOnly = false,
  viewOnly = false,
  add = false,
  required = true,
  pdfOnly = false,
  csvOnly = false,
  xlsxOnly = false,
  pdfImageOnly = false,
  setCsvFile,
  setLoading,
  isAllowSameFileUpload = false,
  maxSizeMB = 15// Default maximum file size in MB
}) => {
  const fileInputRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(data ? data : "");
  const [isEdit, setIsEdit] = useState(true);

  // const handleFileChange = async (event) => {
  //   try {
  //     const file = event.target.files[0];
  //     console.log(file, 'file!!!!!!!!!!!!')
  //     if (!file) return;

  //     // Check for allowed file types
  //     if (!file) return;

  //     // Determine allowed file types based on component props
  //     let allowedFileTypes = [];
  //     if (csvOnly) {
  //       allowedFileTypes = [
  //         'application/vnd.ms-excel',
  //         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //         'text/csv'
  //       ];
  //     } if (xlsxOnly) {
  //       allowedFileTypes = [
  //         'application/vnd.ms-excel',
  //         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  //       ];
  //     } else if (pdfOnly) {
  //       allowedFileTypes = [
  //         'application/pdf'
  //       ];
  //     } else if (imageOnly) {
  //       allowedFileTypes = [
  //         'image/png',
  //         'image/jpeg'
  //       ];
  //     } else {
  //       allowedFileTypes = [
  //         'application/pdf',
  //         'image/png',
  //         'image/jpeg'
  //       ];
  //     }

  //     // Check for allowed file types
  //     if (!allowedFileTypes.includes(file.type)) {
  //       toast.error(`Invalid file type. Please upload a ${csvOnly ? 'CSV or Excel' : xlsxOnly ? 'Excel' : pdfOnly ? 'PDF': imageOnly ? 'PNG or JPEG' : 'PDF or PNG'} file.`);
  //       return;
  //     }

  //     setCsvFile && setCsvFile(file);

  //     const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert maxSizeMB to bytes

  //     if (file.size > maxSizeBytes) {
  //       // File size exceeds maxSizeMB, handle accordingly
  //       toast.info(`File size exceeds ${maxSizeMB} MB. Please upload a file of size less than ${maxSizeMB} MB.`);
  //       return;
  //     }

  //     const dataForFile = { 'null': null, file };
  //     handleupload(dataForFile, 'done', name, true, setValue, trigger, setUploadedFile, setIsEdit, setLoading);
  //   } catch (error) {
  //     console.error('Error uploading file:', error);
  //   }
  // };

  const handleFileChange1 = async (event) => {
    try {
      const file = event.target.files[0];
      console.log(file, 'file!!!!!!!!!!!!');
      if (!file) return;

      // Determine allowed file types based on component props
      let allowedFileTypes = [];
      let allowedExtensions = [];
      if (csvOnly) {
        allowedFileTypes = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'text/csv'
        ];
        allowedExtensions = ['.csv', '.xls', '.xlsx'];
      } else if (xlsxOnly) {
        allowedFileTypes = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        allowedExtensions = ['.xls', '.xlsx'];
      } else if (pdfOnly) {
        allowedFileTypes = [
          'application/pdf'
        ];
        allowedExtensions = ['.pdf'];
      } else if (imageOnly) {
        allowedFileTypes = [
          'image/png',
          'image/jpeg'
        ];
        allowedExtensions = ['.png', '.jpg', '.jpeg'];
      } else {
        allowedFileTypes = [
          'application/pdf',
          'image/png',
          'image/jpeg'
        ];
        allowedExtensions = ['.pdf', '.png', '.jpg', '.jpeg'];
      }

      // Check for allowed file types
      if (!allowedFileTypes.includes(file.type)) {
        toast.error(`Invalid file type. Please upload a ${csvOnly ? 'CSV or Excel' : xlsxOnly ? 'Excel' : pdfOnly ? 'PDF' : imageOnly ? 'PNG or JPEG' : 'PDF or PNG'} file.`);
        return;
      }

      // Check for allowed file extensions
      // const fileExtension = file.name.split('.').pop().toLowerCase();
      // const fileExtension = file.name.slice(file.name.lastIndexOf('.') - 1).toLowerCase();
      const filename = file.name.toLowerCase();
      // Split by the last dot (.) to extract the extension
      const lastDotIndex = filename.lastIndexOf('.');
      const fileExtension = filename.slice(lastDotIndex + 1);
      
      // Get the file name without the last extension (the actual base extension)
      const baseExtension = filename.slice(0, lastDotIndex).split('.').pop();
      
      console.log(fileExtension, 'fileExtension!!!!!!');
      console.log(baseExtension, 'baseExtension!!!!!!');
      
      // Define a list of forbidden extensions (e.g., `.exe`)
      const forbiddenExtensions = ['exe', 'bat', 'com', 'sh'];  // Add more extensions as needed
      
      // Check if the base extension is forbidden
      if (forbiddenExtensions.includes(baseExtension)) {
        toast.error('This file type is not allowed.');
        return;
      }
      
      if (!allowedExtensions.includes(fileExtension)) {
        toast.error(`Invalid file extension. Please upload a valid file.`);
        return;
      }

      if (!allowedExtensions.includes(`.${fileExtension}`)) {
        toast.error(`Invalid file extension. Please upload a ${csvOnly ? 'CSV or Excel' : xlsxOnly ? 'Excel' : pdfOnly ? 'PDF' : imageOnly ? 'PNG or JPEG' : 'PDF or PNG'} file.`);
        return;
      }

      setCsvFile && setCsvFile(file);

      const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert maxSizeMB to bytes

      if (file.size > maxSizeBytes) {
        // File size exceeds maxSizeMB, handle accordingly
        toast.info(`File size exceeds ${maxSizeMB} MB. Please upload a file of size less than ${maxSizeMB} MB.`);
        return;
      }

      const dataForFile = { 'null': null, file };
      handleupload(dataForFile, 'done', name, true, setValue, trigger, setUploadedFile, setIsEdit, setLoading);
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  const handleFileChange = async (event) => {
    try {
        const file = event.target.files[0];
        console.log(file, 'file!!!!!!!!!!!!');
        if (!file) return;

        // Determine allowed file types based on component props
        let allowedFileTypes = [];
        let allowedExtensions = [];
        if (csvOnly) {
            allowedFileTypes = [
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'text/csv'
            ];
            allowedExtensions = ['.csv', '.xls', '.xlsx'];
        } else if (xlsxOnly) {
            allowedFileTypes = [
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];
            allowedExtensions = ['.xls', '.xlsx'];
        } else if (pdfOnly) {
            allowedFileTypes = [
                'application/pdf'
            ];
            allowedExtensions = ['.pdf'];
        } else if (imageOnly) {
            allowedFileTypes = [
                'image/png',
                'image/jpeg'
            ];
            allowedExtensions = ['.png', '.jpg', '.jpeg'];
        } else {
            allowedFileTypes = [
                'application/pdf',
                'image/png',
                'image/jpeg'
            ];
            allowedExtensions = ['.pdf', '.png', '.jpg', '.jpeg'];
        }

        // Check for allowed file types
        if (!allowedFileTypes.includes(file.type)) {
            toast.error(`Invalid file type. Please upload a ${csvOnly ? 'CSV or Excel' : xlsxOnly ? 'Excel' : pdfOnly ? 'PDF' : imageOnly ? 'PNG or JPEG' : 'PDF or PNG'} file.`);
            return;
        }

        // Check for allowed file extensions
        const fileExtension = file.name.split('.').pop().toLowerCase();
        console.log(fileExtension, 'fileExtension!!!!!!');
        if (!allowedExtensions.includes(`.${fileExtension}`)) {
            toast.error(`Invalid file extension. Please upload a ${csvOnly ? 'CSV or Excel' : xlsxOnly ? 'Excel' : pdfOnly ? 'PDF' : imageOnly ? 'PNG or JPEG' : 'PDF or PNG'} file.`);
            return;
        }

        // Additional check to ensure the file name does not contain multiple extensions
        const fileNameParts = file.name.split('.');
        if (fileNameParts.length > 2) {
            toast.error('Invalid file name. Please ensure the file has a single extension.');
            return;
        }

        setCsvFile && setCsvFile(file);

        const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert maxSizeMB to bytes

        if (file.size > maxSizeBytes) {
            // File size exceeds maxSizeMB, handle accordingly
            toast.info(`File size exceeds ${maxSizeMB} MB. Please upload a file of size less than ${maxSizeMB} MB.`);
            return;
        }

        const dataForFile = { 'null': null, file };
        handleupload(dataForFile, 'done', name, true, setValue, trigger, setUploadedFile, setIsEdit, setLoading);
    } catch (error) {
        console.error('Error uploading file:', error);
    }
};

  const handleEdit = () => {
    if (fileInputRef.current) {
      if(isAllowSameFileUpload){
        fileInputRef.current.value = "";
      }  
      fileInputRef.current.click();
    }
  };

  const handleView = (doc_url) => {
    const fileUrl = doc_url;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    link.setAttribute('download', `sample.${doc_url?.slice(-3)}`);
    document.body.appendChild(link);
    link.click();
  };

  const getFileType = (fileName) => {
    if (fileName?.endsWith('.pdf')) {
      return 'pdf';
    } else if (fileName?.endsWith('.csv')) {
      return 'csv';
    } else if (fileName?.endsWith('.xls')) {
      return 'xls';
    } else if (fileName?.endsWith('.xlsx')) {
      return 'xlsx';
    } else if (fileName) {
      return 'image';
    } else {
      return 'default';
    }
  };

  useEffect(() => {
    setUploadedFile(data);
    setValue && setValue(name, data);
  }, [data]);

  return (
    <div>
      {!viewOnly && (
        <input
          type="file"
          onChange={handleFileChange}
          name={name}
          accept={imageOnly ? ".jpg, .jpeg, .png, .JPG, .JPEG, .PNG" : pdfOnly ? ".pdf" : csvOnly ? ".csv" : xlsxOnly ? ".xls, .xlsx" : pdfImageOnly ? ".pdf, .jpg, .jpeg, .png, .JPG, .JPEG, .PNG" : undefined}
          style={{ display: 'none' }}
          ref={fileInputRef}
          {...register(name, { required: required })}
        // {...register(name)}
        />
      )}

      <div className="blog-box blog-grid text-center product-box">
        <div className="product-img">
          <Media
            style={{ width: '180px', margin: 'auto' }}
            className="img-fluid top-radius-blog data-table-row-image-auto"
            src={
              getFileType(uploadedFile) == 'pdf' ? require('../../assets/images/pdf-thumbnail.png')
                : getFileType(uploadedFile) == 'csv' ? require('../../assets/images/csv.png')
                  : getFileType(uploadedFile) == 'xls' ? require('../../assets/images/xls.png')
                    : getFileType(uploadedFile) == 'xlsx' ? require('../../assets/images/xls.png')
                      : uploadedFile ? uploadedFile : data ? data.endsWith("pdf") ? require('../../assets/images/pdf-thumbnail.png') : data.endsWith("csv") ? require('../../assets/images/csv.png') : data : require('../../assets/images/file-upload.png')
            }
            alt=""
          />

          <div className="product-hover">
            <ul>
              {!add && <li onClick={() => handleView(uploadedFile)}>
                <i title='View file' className="icon-link"></i>
              </li>}

              {!viewOnly && <li onClick={handleEdit}>
                <i title={add ? 'Add file' : 'Edit file'} className={add ? "fa fa-plus" : "fa fa-pencil"}></i>
              </li>}
            </ul>
          </div>
          {!viewOnly && (
            <small style={{ color: "#2b262691" }}>{imageOnly ? "(.jpg, .png allowed only)" : pdfOnly ? "(.pdf allowed only)" : csvOnly ? "(.csv allowed only)" : xlsxOnly ? "(.xls or .xlsx allowed only)" : "(.pdf, .jpg, .png allowed only)"}</small>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileUploadComponent;
